import { Link } from '@/i18n/navigation';
import { cn } from '@/helpers/utils';
import SvgLogo from './svg/SvgLogo';
import LanguageSwitcherMobile from './LanguageSwitcherMobile';

type LogoMobileProps = {
    active: boolean;
    onLanguageChange: () => void;
};

export default function LogoMobile({ active, onLanguageChange }: LogoMobileProps) {
    return (
        <div className="block xl:hidden w-[166px] h-[87px] relative">
            <div
                className={cn(
                    'absolute py-7 transform transition-all duration-500',
                    active && '-translate-y-full opacity-0'
                )}
            >
                <Link href="/" className="inline-flex text-purple-800">
                    <SvgLogo width="166" height="26" />
                </Link>
            </div>

            <div
                className={cn(
                    'absolute z-50 transform transition-all duration-500',
                    !active && '-translate-y-full opacity-0'
                )}
            >
                <LanguageSwitcherMobile onClick={onLanguageChange} />
            </div>
        </div>
    );
}
